import { Image, ImageSourcePropType, ImageStyle, KeyboardTypeOptions, StyleSheet, Text, TextInput, View, ViewStyle } from "react-native"
import { color_333333, color_BEBEBE, color_EEF2F9, color_main, ColorF6F6F6, ColorRed } from "../../assets/style/colors"
import { ImageView } from "../../components/ImageView"
import { ButtonView } from "../../components/ButtonView"

export type CommonInputProp = {
    placeholder: string,
    style?: ViewStyle,
    imgStyle?: ImageStyle,
    source?: ImageSourcePropType,
    secureTextEntry?: boolean,
    isRequired?: boolean,
    text: string,
    onChangeText: (text: string) => void,
    sendText?: string,
    sendCode?: () => void,
    showClean?: boolean
    autoFocus?: boolean
    focusable?: boolean
    keyboardType?: KeyboardTypeOptions
    maxLength?: number
    editable?: boolean
    onFocus?: () => void,
    onBlur?: () => void,
    rightIcon?: React.ReactNode
}
const CommonText = ({ isVis }: { isVis?: boolean }) => (
    isVis && isVis ? <Text style={{ color: ColorRed, position: 'absolute', top: 10, start: 6 }}>*</Text> : null
)
export const CommonInput = (props: CommonInputProp) => {
    return (<View style={[styles.inputBg, { paddingEnd: (props.showClean === true || props.sendText && props.sendText.length > 0) ? 10 : 16 }, props.style]}>
        <CommonText isVis={props.isRequired} />
        {props.source && <Image style={[{ width: 18, height: 18 }, props.imgStyle]} source={props.source} resizeMode="contain" />}
        <TextInput
            placeholder={props.placeholder}
            editable={props.editable}
            focusable={props.focusable}
            autoFocus={props.autoFocus}
            autoCapitalize="none"
            autoComplete={"off"}
            autoCorrect={false}
            selectionColor={color_main}
            placeholderTextColor={color_BEBEBE}
            style={[styles.input, { flex: 1 }]}
            value={props.text}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            maxLength={props.maxLength}
            keyboardType={props.keyboardType}
            secureTextEntry={props.secureTextEntry}
            onChangeText={props.onChangeText} />
        {/* 清除按钮 */}
        {props.showClean === true && props.text.length > 0 && <ImageView
            activeOpacity={1}
            style={{ padding: 6 }}
            onClick={() => {
                props.onChangeText("");
            }} source={require("../../assets/image/icon_del.png")} />}

        {/* 发送验证码按钮 */}
        {props.sendText &&
            <ButtonView
                onPress={() => props.sendCode?.()}
                style={{ padding: 6 }}
                textStyle={{ fontSize: 14, color: color_main }}
                text={props.sendText}
            />
        }

        {props.rightIcon && (
            <View style={{ padding: 6, justifyContent: 'center', alignItems: 'center' }}>
                {props.rightIcon}
            </View>
        )}
    </View>)
}
const styles = StyleSheet.create({
    inputBg: {
        flexDirection: "row",
        backgroundColor: ColorF6F6F6,
        borderRadius: 5,
        alignItems: "center",
        height: 48,
        paddingStart: 16
    },
    input: {
        height: 40,
        flex: 1,
        color: color_333333,
        marginStart: 8
    },
});